import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import mixpanel, { Persistence } from 'mixpanel-browser';

@Injectable({
  providedIn: 'root'
})
export class TrackingService {
  private analystId: string;

  constructor() {
    mixpanel.init(environment.mixpanel.token, {
      debug: environment.mixpanel.debug,
      track_pageview: environment.mixpanel.track_pageview,
      persistence: environment.mixpanel.persistence as Persistence,
    });
  }

  public identify(payload) {
    if (!payload) {
      return
    }

    this.analystId = payload.user_id;
    mixpanel.identify(this.analystId);
    mixpanel.people.set(payload);
  }

  public page(payload) {
    if (!payload) {
      return
    }

    payload = {
      id: this.analystId,
      page_name: payload.page_name,
      url: payload.url,
      data: payload.properties,
    };
    mixpanel.track_pageview(payload, { event_name: payload.page_name });
  }

  public track(title, properties) {
    if (!properties) {
      return
    }

    properties["id"] = this.analystId;
    properties["event_name"] = title;
    mixpanel.track(title, properties);
  }

  public aliasUser(user_id, payload): void {
    if (!payload) {
      return
    }

    mixpanel.alias(user_id);
    mixpanel.people.set(payload);
  }
}
